import { TMessageSchema } from '../../types/messages';

/** Проверяет, удалено ли сообщение  */
export function isMessageDeleted({ status }: TMessageSchema): boolean {
  return status === 'deleted';
}
